// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__a1oRj","addWidgetButton":"Header_addWidgetButton__tJG-t","dashboardTabs":"Header_dashboardTabs__vnDnZ","active":"Header_active__1D5OO"};